module.exports = __webpack_public_path__ + "img/1pachet.ac4bb05f.png";